<template>
	<div class="contact-wrap">
        <h1>联系信息</h1>
        <ul v-if='detailInfo.server_type==1'>
            <li v-for='(item,index) in detailInfo.question_url' :key='index'>
                <img src="../../../assets/img/goodsLink.png">
                <span>商品链接</span>
                <em>{{item}}</em>
            </li>
            <li>
                <img src="../../../assets/img/saler.png">
                <span>卖家旺旺</span>
                <em>{{detailInfo.merchant_wangwang}}</em>
            </li>
            <li>
                <img src="../../../assets/img/buy.png">
                <span>买家旺旺</span>
                <em>{{detailInfo.consumer_wangwang}}</em>
            </li>
        </ul>
        
        <ul v-else>
            <li v-for='(item,index) in detailInfo.question_url' :key='index'>
                <img src="../../../assets/img/goodsLink.png">
                <span>商家网址</span>
                <em>{{item}}</em>
            </li>
            <li>
                <img src="../../../assets/img/saler.png">
                <span>顾客手机</span>
                <em>{{detailInfo.consumer_mobile}}</em>
            </li>
            <li>
                <img src="../../../assets/img/buy.png">
                <span>顾客姓名</span>
                <em>{{detailInfo.consumer_name}}</em>
            </li>
        </ul>
	</div>
</template>

<script>
export default {
    props:{
        detailInfo:{
            type:Object,
            default:()=>{}
        }
    },
    data() {
    	return {
			
		};
    },
  
    methods:{
        
    },
};
</script>

<style lang="scss" scoped>
	.contact-wrap{
        margin-top: 20px;
        h1{
            font-size: 20px;
            @include font-style;
            color: #000000;
        }
        ul{
            margin-top: 20px;
            // width: 540px;
            box-sizing: border-box;
            padding: 30px 0 30px 30px;
            background: #FFFFFF;
            box-shadow: 1px 3px 6px 0px rgba(102, 102, 102, 0.16);
            img{
                width: 18px;
                height: 18px;
            }
            li{
                display: flex;
                align-items: center;
                margin-bottom: 20px;
                @include font-style;
                font-size: 16px;
                span{
                   color: #666666;
                   margin-left: 20px;
                   margin-right: 68px;
                }
                em{
					width: 64%;
					word-break: break-all;
                    font-style: normal;
                    color: #343434;
                } 
            }
            li:last-child{
                margin-bottom: 0;
            }
            
        }
    }
	
</style>